export default __webpack_public_path__ + "ba34f1bb7c8fc116e619bcd6ef3f45ce.svg";